import React, { useMemo } from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { ModalEntryPoint } from '../shared/modal-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import entryPoint, { type EntryPointParams } from './storageHardLimit.entrypoint';

export function StorageHardLimitModal(): React.JSX.Element {
	const { userId } = useEditionAwareness();

	const shouldCheckContactSalesEligibility =
		Boolean(userId) && fg('twcg-1533-pls-contact-path-disco-gate');

	const entryPointParams: EntryPointParams = useMemo(
		() => ({ userId, shouldCheckContactSalesEligibility }),
		[userId, shouldCheckContactSalesEligibility],
	);

	const modalProps = useMemo(() => ({ width: 968, height: 520 }), []);

	return (
		<ModalEntryPoint
			modalProps={modalProps}
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
